// Source:  
export function HighlightMatchingWords() {
    'ngInject';
    return (input, searchTerm) => {
        var searchTerms = searchTerm.replace(/ +/g, " ").split(" ");
        for (var i = 0; i < searchTerms.length; i++) {
            input = input.replace(new RegExp(searchTerms[i], 'gi'), '<strong>$&</strong>')
        }
        return input;
    }
} 


// WEBPACK FOOTER //
// ./src/app/shared/filters/HighlightMatchingWords.js